(() => {
  const loader = document.getElementById('acw-page-loader');

  if (!loader) return;

  const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const isDesignMode = loader.dataset.designMode === 'true';
  const parsedDuration = Number.parseInt(loader.dataset.fadeDuration || '200', 10);
  const fadeDuration = Number.isFinite(parsedDuration) ? parsedDuration : 200;
  const minimumVisibleUntil = performance.now() + 300;
  let completionTimer;
  let hasCompleted = false;
  let isNavigating = false;

  const finish = () => {
    if (hasCompleted) return;

    hasCompleted = true;
    loader.classList.add('is-complete');
    window.setTimeout(() => {
      if (!isNavigating) loader.hidden = true;
    }, fadeDuration);
  };

  const scheduleFinish = () => {
    window.clearTimeout(completionTimer);
    completionTimer = window.setTimeout(finish, Math.max(0, minimumVisibleUntil - performance.now()));
  };

  if (prefersReducedMotion || isDesignMode) {
    loader.hidden = true;
    return;
  }

  if (document.readyState === 'complete') {
    scheduleFinish();
  } else {
    window.addEventListener('load', scheduleFinish, { once: true });
    window.setTimeout(scheduleFinish, 3000);
  }

  window.addEventListener('pageshow', (event) => {
    if (!event.persisted) return;

    isNavigating = false;
    loader.classList.add('is-complete');
    loader.hidden = true;
  });

  document.addEventListener('click', (event) => {
    if (
      event.defaultPrevented ||
      event.button !== 0 ||
      event.metaKey ||
      event.ctrlKey ||
      event.shiftKey ||
      event.altKey
    ) {
      return;
    }

    const link = event.target.closest('a[href]');

    if (
      !link ||
      link.hasAttribute('download') ||
      link.hasAttribute('data-no-page-transition') ||
      (link.target && link.target !== '_self')
    ) {
      return;
    }

    const destination = new URL(link.href, window.location.href);
    const isSamePageAnchor =
      destination.origin === window.location.origin &&
      destination.pathname === window.location.pathname &&
      destination.search === window.location.search &&
      destination.hash;

    if (
      destination.origin !== window.location.origin ||
      !['http:', 'https:'].includes(destination.protocol) ||
      isSamePageAnchor
    ) {
      return;
    }

    event.preventDefault();
    isNavigating = true;
    loader.hidden = false;

    requestAnimationFrame(() => {
      loader.classList.remove('is-complete');
      window.setTimeout(() => window.location.assign(destination.href), Math.min(fadeDuration, 220));
    });
  });
})();
